module.exports = __webpack_public_path__ + "static/media/icon_data-forward.adc7115c.svg";